/**
 * This is exported as a separate function so that we can mock it.
 * @alias isOnServer
 * @internal
 */
export default () => typeof window === 'undefined';
